import { Flex } from "@chakra-ui/react";
import { Icons, Typography, ToolTip } from "@reconvert/react-ui-component";
import React from "react";
import { useAppSelector } from "../../../../app/hooks";
import { selectAppState } from "../../../../app/slice/appSlice";

export interface HelperTextProps {
    text: string;
    showTooltip?: boolean;
    tooltipText?: string;
    showIcon?: boolean;
}

const HelperText: React.FC<HelperTextProps> = ({
    text,
    tooltipText,
    showIcon = true,
    showTooltip = true,
}) => {
    const { isMobile } = useAppSelector(selectAppState);
    
    if (!text) return null;

    return (
        <Flex mt={2} gap={2} alignItems="flex-start" p={2} bg={"#F9FAFC"} borderRadius={"4px"}>
            {showIcon && (
                showTooltip ? (
                    <ToolTip trigger={isMobile ? "click" : "hover"} placement={"top"} label={tooltipText || text} maxWidth={"285px"}>
                        <span style={{ display: "flex", alignItems: "center" }}>
                            <Icons.Question color={"#6A7381"} height={"16px"} width={"16px"} />
                        </span>
                    </ToolTip>
                ) : (
                    <span style={{ display: "flex", alignItems: "center" }}>
                        <Icons.Question color={"#6A7381"} height={"16px"} width={"16px"} />
                    </span>
                )
            )}
            <Typography variant="small" color={"#6A7381"} lineHeight={"20px"}>
                {text}
            </Typography>
        </Flex>
    );
};

export default HelperText;

